import React, { useEffect, useState } from "react";
import PersonalDefaultPage from "./../personal/PersonalDefaultPage";
import { useSelector } from "react-redux";
import { LevelPreview } from "../../components/blocksl/LevelPreview";
import { BsArrowRight } from "react-icons/bs";
import { CgSpinner } from "react-icons/cg";
import {
    OnestBoldDefault,
    OnestNormalDefault,
    OnestNormalSmall,
    OnestSemiBoldBig,
    OnestSemiBoldDefault,
    OnestSemiBoldMed,
    OnestSemiBoldSmall
} from "../../components/styled/TextComponents";
import { PiSpinner } from "react-icons/pi";
import {
    color_grey_dark,
    color_white,
    color_black,
    color_black_light,
    color_red_active,
    color_red_ultra_light,
    color_green,
    color_green_dark,
    color_green_light,
    color_grey_light,
    color_red_default,
} from "../../constants/colors";
import { RotatingLines } from "react-loader-spinner";
import { useWindowDimensions } from "../../utils";
import { BlockTitle } from "../../components/text/BlockTitle";
import { PageTitle } from "../../components/text/PageTitle";
import moment from "moment-timezone";
import { Button } from "../../components/controls/Button/Button";
import ChackedIcon from "../../components/icons/ChackedIcon";
import FaqQuestion from "../../components/faq/FaqQuestion";
import ModalTarifChange from "../../components/blocks/ModalTarifChange";
import ModalQuestion from "../../components/blocks/ModalQuestion";
import ModalSimple from "../../components/blocks/ModalSimple";
import { set } from "react-hook-form";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Config from "../../Config";
import { ButtonDefault } from "../../components/controls/Button/ButtonDefault";
import { useI18n } from "../../i18n/I18nProvider";


export const SuccessNewRecurrentPage = () => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
    const [submitted, setSubmitted] = useState(false);
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };

    const query = useQuery();
    const userId = query.get("user_id");
    const paymentId = query.get("payment_id");
    const isFirst = query.get("is_first");
    const isTrial = query.get("is_trial");


    useEffect(() => {
        if (userId && paymentId) {
            // Здесь можно добавить логику для обработки userId и paymentId, если это необходимо
            console.log("User ID:", userId);
            console.log("Payment ID:", paymentId);
            let backendAddr = Config.BACKEND_ADDR + "/payments/successNewRecurrent/" + userId + "/" + paymentId + "/" + isTrial // /api

            axios.post(backendAddr).then(response => {
                if (response.status === 200) {
                    setSubmitted(true);

                }
            }).catch(err => {
                alert(err.response?.data?.message || err.message)
            })
        } else {
            console.error("User ID or Payment ID is missing in the query parameters.");
        }
    }, [userId, paymentId]);

    return (
        <PersonalDefaultPage style={{ padding: 0, margin: 0, width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{
                width: screenWidth > 504 ? "486px" : screenWidth - 50,
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
            }}>

                <div style={{ display: "flex", justifyContent: "center", marginTop: 32 }}>
                    <img
                        src={window.location.origin + "/Success_perspective.png"}
                        alt={t("Успешно")}
                        style={{ width: 100, height: 100, objectFit: "contain" }}
                    />
                </div>
                {submitted ?
                    <>
                        
                            {
                                isFirst == "True" 
                                ? 
                                    isTrial == "True"
                                    ?
                                    <OnestSemiBoldBig style={{ marginTop: 20, marginBottom: 20, color: color_black, textAlign: "center" }}>
                                        {t("Карта успешно привязана, пробный период активирован!")}
                                    </OnestSemiBoldBig>
                                    : 
                                        <OnestSemiBoldBig style={{ marginTop: 20, marginBottom: 20, color: color_black, textAlign: "center" }}>
                                            {t("Карта успешно обновлена!")}
                                        </OnestSemiBoldBig>
                                :
                                    <OnestSemiBoldBig style={{ marginTop: 20, marginBottom: 20, color: color_black, textAlign: "center" }}>
                                        {t("Оплата прошла успешно!")}
                                    </OnestSemiBoldBig> 

                            } 
                        
                            {
                                isFirst == "True"
                                ? 
                                    isTrial == "True"
                                    ?
                                    <OnestNormalDefault style={{ marginTop: 20, marginBottom: 20, color: color_black_light, textAlign: "center" }}> 
                                        {t("Теперь вы можете начать пользоваться SPEAK")}<span style={{color: color_red_default}}>ID</span>{t(" без ограничений — пробный период продлится 7 дней, затем автоматически спишется сумма выбранного тарифа.")}
                                    </OnestNormalDefault>
                                    :
                                    <OnestNormalDefault style={{ marginTop: 20, marginBottom: 20, color: color_black_light, textAlign: "center"  }}> 
                                        {t("Теперь вы можете продолжить пользоваться SPEAK")}<span style={{color: color_red_default}}>ID</span>{t(" без ограничений. Информацию о тарифе и списаниях вы найдёте в разделе «Управление подпиской».")}
                                    </OnestNormalDefault>
                                :
                                    <OnestNormalDefault style={{ marginTop: 20, marginBottom: 20, color: color_black_light, textAlign: "center"  }}> 
                                        {t("Теперь вы можете продолжить пользоваться SPEAK")}<span style={{color: color_red_default}}>ID</span>{t(" без ограничений. Информацию о тарифе и списаниях вы найдёте в разделе «Управление подпиской».")}
                                    </OnestNormalDefault>
                            }   
                        <div
                            style={{ marginTop: 20 }}
                            onClick={() => window.location.href = "/billing"}
                        >
                            <ButtonDefault
                                width={ screenWidth > 504 ? "486px" : screenWidth - 50 }
                                height={40}
                                active={true}
                            >
                                {t("Открыть платформу")}
                            </ButtonDefault>
                        </div>

                        <OnestNormalSmall style={{ marginTop: 20, marginBottom: 20, width: 331, color: color_grey_dark, textAlign: "center"  }}>
                            {t("Если платформа уже открыта в соседней вкладке, просто закройте это окно")}
                        </OnestNormalSmall>
                    </>
                    :
                    <>
                        <PageTitle>{t("Подключение автоплатежа")}</PageTitle>
                        <OnestNormalDefault style={{ marginTop: 20, marginBottom: 20, textAlign: "center"  }}>
                            {t("Пожалуйста, не закрывайте эту страницу – мы подключаем вашу подписку")}{isTrial == "True" && t(" и настраиваем пробный период")}.
                        </OnestNormalDefault>
                        <OnestNormalSmall style={{ marginTop: 20, marginBottom: 20, textAlign: "center"  }}>
                            {t("Чтобы всё сработало корректно, дождитесь окончания загрузки. Это может занять несколько минут.")}
                        </OnestNormalSmall>
                    </>
                }
            </div>
        </PersonalDefaultPage>
    )
}
